import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "loginFromOther": "Due to prolonged inactivity, your session has expired. Please log in again.",
  "messageRecallFailed": "Messsage recall failed"
})
i18n.mergeLocaleMessage('zh', {
  "loginFromOther": "系统检测您长时间未操作，你的会话已过期，请重新登录",
  "messageRecallFailed": "消息撤回失败"
})
i18n.mergeLocaleMessage('mm', {
  "loginFromOther": "အကြာကြီးလုပ်ငန်းမလုပ်ထားသည့်အတွက် သင်၏ဆက်သွယ်မှုအချိန်ကုန်သွားပြီဖြစ်သောကြောင့် ထပ်မံလော့ဂ်အင်ဝင်ပါ။",
  "messageRecallFailed": "Messsage recall failed"
})
  